module.exports = __webpack_public_path__ + "media/images/sp/stores/fukuoka/fukuoka_concept_02-2e27fd819453d916bca07e45581f03f6.jpg";